module.exports = __webpack_public_path__ + "img/250460827_2025_4-5.fd25a547.png";